module.exports = __webpack_public_path__ + "img/Item5light.f77ee54a.svg";